function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.9556 3.74838L7.39877 7.3052C7.04715 7.15836 6.71098 7.06563 6.37868 7.04438C5.77203 7.00767 5.23493 7.19121 4.74807 7.67807C4.04868 8.37939 4.068 9.31834 4.58771 10.3829C4.96059 11.1499 5.62133 12.0135 6.44437 12.8964L0.638697 18.7001C0.319916 19.0209 0.319916 19.5386 0.638697 19.8594C0.95941 20.1781 1.47719 20.1781 1.7979 19.8594L7.60163 14.0537C8.48456 14.8767 9.34817 15.5375 10.1152 15.9103C11.1797 16.43 12.1187 16.4494 12.82 15.75C13.3068 15.2631 13.4904 14.726 13.4537 14.1194C13.4324 13.7871 13.3397 13.4509 13.1929 13.0993L16.7497 9.54245C17.7678 9.96943 18.645 9.96556 19.1801 9.4304C19.7771 8.83341 19.7153 7.81331 19.1318 6.64831C18.6739 5.73061 17.8799 4.65256 16.8617 3.63632C15.8455 2.61816 14.7674 1.8241 13.8497 1.36622C12.6847 0.782754 11.6646 0.72093 11.0676 1.31792C10.5325 1.85308 10.5286 2.73021 10.9556 3.74838Z",
  fill: "#767B87"
});

const SvgPinSolid = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPinSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin_solid.77078812.svg";
export { ForwardRef as ReactComponent };